import { createNativeStackNavigator } from '@react-navigation/native-stack';
import React from 'react';
import { Platform } from 'react-native';
import { renderAdminStackRoutes } from 'src/modules/admin/adminStackRoutes';
import useIsLoggedIn from 'src/modules/authentication/hooks/useIsLoggedIn';
import useIsSuperAdmin from 'src/modules/authentication/hooks/useIsSuperAdmin';
import { renderDebugStackRoutes } from 'src/modules/debug/debugStackRoutes';
import { renderNotificationStackRoutes } from 'src/modules/notification/notificationStackRoutes';
import { renderReviewPipelineStackRoutes } from 'src/modules/review-pipeline/reviewPipelineStackRoutes';
import { renderSTCStackRoutes } from 'src/modules/support-the-creators/stcStackRoutes';
import useI18n from 'src/modules/translations/hooks/useI18n';
import { renderUserStackRoutes } from 'src/modules/user/userStackRoutes';
import renderAuthRoutes from '../modules/authentication/authRoutes';
import { renderExamPreparationStackRoutes } from '../modules/exam-preparation/examPreparationStackRoutes';
import NavigationWrapper from './NavigationWrapper';
import { renderTabStackRoutes } from './TabNavigation';
export const RootStack = createNativeStackNavigator();
const stackNavigationOptions = {
    headerShown: false,
    gestureEnabled: Platform.OS === 'ios',
};
const RootNavigation = ({ ...navigationWrapperProps }) => {
    const isLoggedIn = useIsLoggedIn();
    const isSuperAdmin = useIsSuperAdmin();
    const { translate } = useI18n();
    const routeRenderProps = { translate };
    return (React.createElement(NavigationWrapper, { ...navigationWrapperProps },
        React.createElement(RootStack.Navigator, { initialRouteName: "Login", screenOptions: stackNavigationOptions }, !isLoggedIn ? (renderAuthRoutes()) : (React.createElement(React.Fragment, null,
            renderTabStackRoutes(routeRenderProps),
            renderExamPreparationStackRoutes(routeRenderProps),
            renderNotificationStackRoutes(routeRenderProps),
            renderUserStackRoutes(routeRenderProps),
            renderReviewPipelineStackRoutes(routeRenderProps),
            __DEV__ && renderDebugStackRoutes(routeRenderProps),
            renderSTCStackRoutes(routeRenderProps),
            isSuperAdmin && renderAdminStackRoutes(routeRenderProps))))));
};
export default RootNavigation;
